<template>
  <div>
    <div class="left-container"><version-list ref="versions" /></div>
    <div class="right-container">
      <version-info :version-id="versionId" @updated="updated" />
      <version-story-list :version-id="versionId" />
    </div>
  </div>
</template>

<script>
import VersionList from '@/pages/project/version/components/VersionList';
import VersionInfo from '@/pages/project/version/components/VersionInfo';
import VersionStoryList from '@/pages/project/version/components/VersionStoryList';
export default {
  components: { VersionList, VersionInfo, VersionStoryList },
  data() {
    return {
      versionId: null
    };
  },
  watch: {
    $route() {
      this.versionId = parseInt(this.$route.query.version_id) || null;
    }
  },
  mounted() {
    this.versionId = parseInt(this.$route.query.version_id) || null;
  },
  methods: {
    updated() {
      this.$refs.versions.getVersionList();
    }
  }
};
</script>

<style lang="less" scoped>
.left-container {
  float: left;
  margin-right: 2px;
  margin-left: -16px;
  height: calc(~'100vh - 130px');
}
.right-container {
  position: relative;
  z-index: 10;
  display: block;
  max-height: calc(~'100vh - 130px');
  overflow: auto;
  border-radius: 2px;
}
</style>
